import {
  DEVICE_GATE_VERDICTS,
  SUPPORTED_DEVICE_TYPES,
  VIEWPORT_CLASSES,
  type DeviceGateVerdict,
  type SupportedDeviceType,
  type ViewportClass,
} from './shared-responder-v2-core-session.consts';

/**
 * The device gate shown before `Intro`. A project with no
 * `supportedDeviceTypes` at all never restricted devices, so it must
 * fail open rather than block every responder. The Figma copy phrases the
 * gate as "On a phone or tablet?", which is why `tablet` groups with
 * `mobile` as "not a computer" rather than with `desktop`.
 */
export function resolveDeviceGate(args: {
  supportedDeviceTypes: readonly SupportedDeviceType[];
  viewportClass: ViewportClass;
}): DeviceGateVerdict {
  if (args.supportedDeviceTypes.length === 0) {
    return DEVICE_GATE_VERDICTS.Allowed;
  }

  const isComputer = args.viewportClass === VIEWPORT_CLASSES.Desktop;

  if (isComputer) {
    return args.supportedDeviceTypes.includes(SUPPORTED_DEVICE_TYPES.Computer)
      ? DEVICE_GATE_VERDICTS.Allowed
      : DEVICE_GATE_VERDICTS.NeedsPhone;
  }

  return args.supportedDeviceTypes.includes(SUPPORTED_DEVICE_TYPES.Phone)
    ? DEVICE_GATE_VERDICTS.Allowed
    : DEVICE_GATE_VERDICTS.NeedsComputer;
}
